import React from "react";

export default function BestIELTSCoaching() {
  return (
    <main className="mt-5 mx-20 px-2 sm:px-4">

      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
        Why Choose Shivasya – The Best IELTS Coaching in Ahmedabad?
      </h1>

      <div className="space-y-4 text-gray-700 text-base leading-relaxed">
        <p className="text-justify">
          Ahmedabad is a growing hub for overseas education and immigration aspirants. With increasing demand for IELTS preparation, choosing the right coaching institute becomes essential.
        </p>

        <p className="text-justify">
          At Shivasya, we understand that IELTS is a life-changing milestone in your international journey.
        </p>
      </div>

      <h2 className="mt-10 text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
        What Makes Shivasya Different?
      </h2>

      <ul className="list-disc mx-10 space-y-3 text-gray-700 text-base">
        <li>Experienced and Certified Trainers</li>
        <li>Personalized Learning Approach</li>
        <li>Regular Mock Tests and Performance Analysis</li>
        <li>Updated Study Materials</li>
        <li>Online and Offline Coaching Options</li>
        <li>Flexible Batch Timings</li>
        <li>Individual Speaking and Writing Feedback</li>
      </ul>

      <div className="mt-6 space-y-4 text-gray-700 text-base leading-relaxed">
        <p className="text-justify">
          We focus on helping students build confidence, improve language accuracy, and achieve their target band scores efficiently.
        </p>

        <p className="text-justify">
          In today’s digital era, we also offer Online IELTS Coaching for students seeking flexibility, affordability, and personalized attention.
        </p>
      </div>

      <h2 className="mt-10 text-2xl sm:text-3xl font-bold text-gray-900 mb-6">
        Start Your IELTS Journey with Confidence
      </h2>

      <div className="space-y-4 text-gray-700 text-base leading-relaxed">
        <p className="text-justify">
          With hundreds of IELTS training centers available in Ahmedabad, selecting the right institute can be challenging. Shivasya simplifies your preparation journey with structured programs and expert mentorship.
        </p>

        <p className="text-justify">
          Take the first step toward your global academic and professional aspirations with trusted IELTS coaching support.
        </p>

        <p className="font-semibold">
          Contact us today to book your demo session and begin your success journey.
        </p>
      </div>

    </main>
  );
}